import ProjectsAPI from 'dashboard/api/projects';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
  meta: {
    count: 0,
    currentPage: 1,
    totalPages: 1,
  },
};

const getters = {
  getProjects: $state => $state.records,
  getProjectUIFlags: $state => $state.uiFlags,
  getProjectMeta: $state => $state.meta,
  getProjectById: $state => id =>
    $state.records.find(c => Number(c.id) === Number(id)),
};

const actions = {
  async fetchProjects({ commit }, params = {}) {
    commit('setProjectUIFlag', { isFetching: true });
    try {
      const response = await ProjectsAPI.get(params);
      commit('setProjects', response.data.payload);
      commit('setProjectMeta', response.data.meta);
      return response.data;
    } finally {
      commit('setProjectUIFlag', { isFetching: false });
    }
  },

  async fetchProject({ commit }, { id }) {
    commit('setProjectUIFlag', { isFetchingItem: true });
    try {
      const response = await ProjectsAPI.show(id);
      commit('addOrUpdateProject', response.data);
      return response.data;
    } finally {
      commit('setProjectUIFlag', { isFetchingItem: false });
    }
  },

  async createProject({ commit }, projectData) {
    commit('setProjectUIFlag', { isCreating: true });
    try {
      const response = await ProjectsAPI.create(projectData);
      commit('addOrUpdateProject', response.data);
      return response.data;
    } finally {
      commit('setProjectUIFlag', { isCreating: false });
    }
  },

  async updateProject({ commit }, { id, ...projectData }) {
    commit('setProjectUIFlag', { isUpdating: true });
    try {
      const response = await ProjectsAPI.update(id, projectData);
      commit('addOrUpdateProject', response.data);
      return response.data;
    } finally {
      commit('setProjectUIFlag', { isUpdating: false });
    }
  },

  async deleteProject({ commit }, id) {
    commit('setProjectUIFlag', { isDeleting: true });
    try {
      await ProjectsAPI.delete(id);
      commit('removeProject', id);
    } finally {
      commit('setProjectUIFlag', { isDeleting: false });
    }
  },

  async applyPlaybook({ commit }, { id, playbookId }) {
    commit('setProjectUIFlag', { isUpdating: true });
    try {
      const response = await ProjectsAPI.applyPlaybook(id, playbookId);
      commit('addOrUpdateProject', response.data);
      return response.data;
    } finally {
      commit('setProjectUIFlag', { isUpdating: false });
    }
  },
};

const mutations = {
  setProjectUIFlag($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
  setProjects($state, projects) {
    $state.records = projects || [];
  },
  setProjectMeta($state, meta = {}) {
    $state.meta = {
      count: meta.count || 0,
      currentPage: meta.current_page || 1,
      totalPages: meta.total_pages || 1,
    };
  },
  addOrUpdateProject($state, project) {
    if (!project || !project.id) return;
    const index = $state.records.findIndex(c => c.id === project.id);
    if (index === -1) {
      $state.records = [project, ...$state.records];
    } else {
      const next = [...$state.records];
      next[index] = project;
      $state.records = next;
    }
  },
  removeProject($state, id) {
    $state.records = $state.records.filter(c => c.id !== id);
  },
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations,
};
